import type {GridFilterOperator} from "@mui/x-data-grid-premium";
import type {PartGridRowModel} from "../CategorizationTableDataModel.ts";
import {EmptyInputComponent} from "./EmptyInputComponent.tsx";

export const CAT_EQ_OPERATOR = {
    operatorValue: 'equalsPrevious',
    label: 'Same category',
}

export const CAT_NEQ_OPERATOR = {
    operatorValue: 'doesNotEqualPrevious',
    label: 'Different category',
}

// Taken from https://mui.com/x/react-data-grid/filtering/customization/#create-a-custom-operator

export const CATEGORY_FILTER_OPERATORS: GridFilterOperator<PartGridRowModel, number>[] = [
    {
        label: CAT_NEQ_OPERATOR.label,
        headerLabel: CAT_NEQ_OPERATOR.label,
        value: CAT_NEQ_OPERATOR.operatorValue,
        getApplyFilterFn: () => null, // Backend only
        InputComponent: EmptyInputComponent,
        requiresFilterValue: false,
    },
    {
        label: CAT_EQ_OPERATOR.label,
        headerLabel: CAT_EQ_OPERATOR.label,
        value: CAT_EQ_OPERATOR.operatorValue,
        getApplyFilterFn: () => null, // Backend only
        InputComponent: EmptyInputComponent,
        requiresFilterValue: false,
    },
    {
        label: 'Filtered by bars', // TODO: Better naming is needed here
        value: 'equals',
        getApplyFilterFn: () => null, // Backend only
        requiresFilterValue: false,
    },
];